import { FlatTreeControl } from '@angular/cdk/tree';
import { TreeNode } from '@app/features/hierarchy/models/hierarchy.model';
import { ReplaySubject } from 'rxjs';
import { TreeDataSource } from '../../pages/manager/edit/node-tree/node-tree.datasource';

export abstract class TreeService<T extends TreeDataSource> {
  // Tree control
  treeControl: FlatTreeControl<TreeNode>;

  // Tree data source
  dataSource: T;
  dataSource$ = new ReplaySubject<T>();

  getLevel = (node: TreeNode) => node.level;
  isExpandable = (node: TreeNode) => node.childrenCount > 0;

  constructor() {
    this.initialize();
  }

  public abstract initialize();
}
